<li class="nav-item">
  <button (click)="cancel()" class="nav-link btn btn-danger text-white mr-2" href="#"><i class="fa fa-window-close" aria-hidden="true"></i> {{ "cancelAction" | language }}</button>
</li>